// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"72165773","453":"eda07d42","455":"9e906e49","977":"58492f22"}[chunkId] + ".chunk.js";
};